import loadable from "@loadable/component";
import { useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { ErrorBoundary } from "../../../components";
import FullPageLoader from "@Components/FullPageLoader";
import NotFound from "@Pages/NotFound";
import loadData from "../data";
import { AppState } from "@Store/index";
import {
  fetchBookingDetailsIfNeeded,
  shouldFetchBookingDetails,
} from "../data/bookingDetailsReducer";

const BookingDetails = loadable(() => import("./BookingDetails"), {
  fallback: <FullPageLoader />,
});

export default (props: any): JSX.Element => {
  const dispatch = useDispatch();
  const inventoryId = props?.match?.params?.id;

  const { readyStatus, data, currentInventoryId } = useSelector(
    ({ bookingDetailsData }: AppState) => ({
      readyStatus: bookingDetailsData.readyStatus,
      data: bookingDetailsData.data,
      currentInventoryId: bookingDetailsData.inventoryId,
    }),
    shallowEqual,
  );

  // Fetch data on client-side for SPA navigation
  useEffect(() => {
    if (__CLIENT__) {
      dispatch(fetchBookingDetailsIfNeeded(props));
    }
  }, [inventoryId]);

  const needsFetch = shouldFetchBookingDetails(
    { bookingDetailsData: { readyStatus, inventoryId: currentInventoryId } } as AppState,
    inventoryId,
  );
  const isLoading = readyStatus === "invalid" || readyStatus === "request" || needsFetch;
  const isError = readyStatus === "failure";
  const showFullPageLoader = isLoading && !data;

  if (isError) {
    return <NotFound isStatus500 {...props} />;
  }

  if (showFullPageLoader) {
    return <FullPageLoader />;
  }

  return (
    <ErrorBoundary>
      <BookingDetails {...props} />
    </ErrorBoundary>
  );
};

export { loadData };
